import { useDialog } from "@datanac/datanac-mui-toolkit";
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";

import { AccountIcon, LogoutIcon } from "../../Icons/Icons";

export const UserInfo = ({ myUser, activeAgent, handleNavigate, handleLogoutClick, pathname }) => {
  const { component: confirmDialog, actions: confirmDialogActions } = useDialog();

  const handleLogout = () => {
    confirmDialogActions.confirm({
      title: "Logout",
      prompt: "Are you sure you want to log out?",
      callback: handleLogoutClick,
    });
  };

  return (
    <Box sx={{ width: "100%", p: 0, m: 0, mb: "0px", marginTop: "auto" }}>
      {confirmDialog}
      <List>
        <ListItemButton
          sx={{
            py: 1,
            pl: 1.5,
            pr: 1,
            minHeight: "48px",
            color: pathname === "/change-totp" ? "secondary.main" : "inherit",
            borderRightStyle: "solid",
            borderRightWidth: "6px",
            borderRightColor: pathname === "/change-totp" ? "secondary.main" : "transparent",
          }}
          onClick={() => handleNavigate(`/change-totp`)}
        >
          <ListItemIcon sx={{ mr: 1, minWidth: 32 }}>
            <AccountIcon color={pathname === "/change-totp" && "secondary"} />
          </ListItemIcon>
          <ListItemText
            primary={
              <>
                <Stack display="flex" direction="row" alignItems="center" sx={{ m: 0, p: 0 }}>
                  {!activeAgent && (
                    <Typography variant="body1" sx={{ maxWidth: "170px", overflow: "clip" }}>
                      {myUser?.name}
                    </Typography>
                  )}
                  {Boolean(activeAgent) && (
                    <Typography variant="body1" sx={{ overflow: "clip", textTransform: "capitalize" }}>
                      {activeAgent?.first_name?.toLowerCase()}
                      <> </>
                      {activeAgent?.middle_name?.toLowerCase()}
                      <> </>
                      {activeAgent?.last_name?.toLowerCase()}
                      <> </>
                      {activeAgent?.business_name?.toLowerCase()}
                    </Typography>
                  )}
                  <Box sx={{ ml: "auto" }} justifyContent="flex-end">
                    <IconButton
                      onClick={(e) => {
                        handleLogout();
                        e.stopPropagation();
                        return false;
                      }}
                    >
                      <LogoutIcon
                        color={pathname === "/change-totp" && "secondary"}
                        sx={{ width: "18px", height: "18px" }}
                      />
                    </IconButton>
                  </Box>
                </Stack>
              </>
            }
          />
        </ListItemButton>
        {import.meta.env.VITE_VERSION && (
          <ListItem>
            <ListItemText sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Typography variant="caption" color="GrayText">
                v{import.meta.env.VITE_VERSION}
              </Typography>
            </ListItemText>
          </ListItem>
        )}
      </List>
    </Box>
  );
};
